import {
  Box,
  Typography
} from "@mui/material";
import TPLSlidePanel from "./TPLSlidePanel";
import ParkTrailButtons from "../map/ParkTrailButtons";


export default function Evaluate() {

  return (
    <TPLSlidePanel>
      <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        width="100%"
      >
        <Box width="80%">
          <Typography
            variant="h2"
            color="grass.main"
            sx={{ marginBottom: "10px" }}
          >
            ParkEvaluator™
          </Typography>
          <Typography variant="bodyBold">
            Draw in potential new parks and/or trails to see their impact on
            park access in your city!
          </Typography>
          <Typography
            variant="body1"
            sx={{ marginBottom: "10px", marginTop: "10px" }}
          >
            Click on "Park" or "Trail" below to start drawing on the map. Double
            click on the map to complete the park or trail.
          </Typography>
          <Typography variant="body1" sx={{ marginBottom: "10px" }}>
            You can add up to five parks and/or trails.{" "}
          </Typography>
          <Typography variant="body1" sx={{ marginBottom: "10px" }}>
            Click "Run Analysis" to see the impact of these new recreational
            resources!{" "}
          </Typography>
          <Typography variant="body1">
            Please allow several minutes for processing
          </Typography>
        </Box>

        <Box width="80%" sx={{ marginTop: "15px" }}>
          <Box
            display="flex"
            flexDirection="row"
            alignItems="center"
            justifyContent="left"
            alignContent="center"
          >
            <Typography variant="button">CHOOSE WHAT TO DRAW:</Typography>
          </Box>
        </Box>
        <div id="parkbuttons"></div>
        <ParkTrailButtons />
        <Box width="80%" sx={{ marginTop: "15px" }}>
          <Typography variant="bodyBold">User-Generated Elements</Typography>
          <Box
            display="flex"
            flexDirection="column"
            sx={{ marginTop: 1, gap: "10px" }}
            px={2}
            py={1}
          >
            <Box
              display="flex"
              flexDirection="row"
              justifyContent="start"
              alignItems="center"
              fontSize="12px"
            >
              <Box
                sx={{
                  height: "15px",
                  width: "15px",
                  borderColor: "#004f00",
                  borderStyle: "solid",
                  borderRadius: "4px",
                  backgroundColor: "#ccebcb",
                }}
              />{" "}
              <Box sx={{ marginLeft: "10px" }}>New Park Area</Box>
            </Box>
            <Box
              display="flex"
              flexDirection="row"
              justifyContent="start"
              alignItems="center"
              fontSize="12px"
            >
              <Box
                sx={{
                  height: "0px",
                  width: "15px",
                  borderColor: "#FFA500",
                  borderStyle: "solid",
                  borderRadius: "1px",
                }}
              />{" "}
              <Box sx={{ marginLeft: "10px" }}>New Trail</Box>
            </Box>
            <Box
              display="flex"
              flexDirection="row"
              justifyContent="start"
              alignItems="center"
              fontSize="12px"
            >
              <Box
                sx={{
                  height: "15px",
                  width: "15px",
                  borderColor: "#afbd42",
                  borderStyle: "solid",
                  borderRadius: "4px",
                  backgroundColor: "#dde880",
                }}
              />{" "}
              <Box sx={{ marginLeft: "10px" }}>New 10-minute Walk Area</Box>
            </Box>
          </Box>
        </Box>
      </Box>
    </TPLSlidePanel>
  );
}
